<router-outlet></router-outlet>

<div class="loader" id="loader1"></div>
<a
  href="javascript:void(0)"
  data-toggle="modal"
  data-target="#myLogoutModel"
  id="logoutopen"
  aria-label="Bankexec"
></a>
<div
  class="modal fade login_popup_style"
  id="myLogoutModel"
  role="dialog"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Account Locked</h4>
      </div>
      <div style="text-align: center" class="modal-body">
        <p>
          Your account has been locked.Please click the button below to return
          to the login screen.
          <br />
        </p>
        <button
          type="button"
          (click)="logout()"
          class="btn btn-primary"
          data-dismiss="modal"
        >
          Return to Login Page
        </button>
      </div>
      <!-- <div class="modal-footer"> -->
      <!-- </div> -->
    </div>
  </div>
</div>

<a
  href="javascript:void(0)"
  data-toggle="modal"
  data-target="#AccountLockModel"
  id="logout_popup"
  aria-label="Bankexec"
></a>
<div
  class="modal fade login_popup_style"
  id="AccountLockModel"
  role="dialog"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Account Locked</h4>
      </div>
      <div style="text-align: center" class="modal-body">
        <p>
          Your Decisions have been submitted for competition. You will now be
          logged out and will not be able to log back in until your Instructor
          opens the next decision period.
          <br />
        </p>
        <button
          type="button"
          (click)="logout()"
          class="btn btn-primary"
          data-dismiss="modal"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>
